import kebabCase from 'lodash.kebabcase';

export const openAccountLink = (selectedOption) =>
    selectedOption === 'etf'
        ? `/personal-investing/account-finder/all-t-rowe-price-accounts.html#brokerage`
        : `/personal-investing/account-finder/index.html`;

export const conversionProcesLink = `/personal-investing/about/client-benefits/faqs.html#conversion-process`;

// IIRT-350: sort of deprecated but can be used if closed funds makes a comeback
export const learnSummitMoreLink = (path) =>
    path === '/closed-funds'
        ? `https://www.troweprice.com/personal-investing/about/client-benefits/index.html?src=summit-closed-fund`
        : `https://www.troweprice.com/personal-investing/about/client-benefits/index.html?src=summit-iclass`;

export const selectorEncode = (str) => kebabCase(str);

export const makeAnchor = (str) => `content-${selectorEncode(str)}`;

export const addFundToCart = (ticker) => {
    window.location.href = `/usis/nasu/account-finder?selectedFund=${ticker}`;
};

export const hostCheck = (host) => {
    if (host.split('.')[0] === 'wwwdev') return 'https://wwwdev.troweprice.com';
    if (host.split('.')[0] === 'wwwstage' || host.split('.')[0] === 'wwwsit')
        return 'https://wwwstage.troweprice.com';
    if (host.split('.')[0] === 'www') return 'https://www.troweprice.com';
    return null;
};

export const generateHashNum = () => {
    const newDate = new Date();
    return `${newDate.getMonth() +
        1}${newDate.getDate()}${newDate.getHours()}10`;
};

export const quickSearchHandleChange = (selectedOption) => {
    window.location.href = `/personal-investing/tools/fund-research/${
        selectedOption.etf ? 'etf/' : ''
    }${selectedOption.value}`;
};
